import {EventMember} from '@wix/ambassador-events-ui-v1-widget-data/types'
import {State} from '../types/state'

export const getEventMembers = (state: State, eventId: string): EventMember[] | undefined => {
  const {members} = state.members
  return members?.[eventId]?.members
}
